export default "__VITE_ASSET__qLAfD8Sd__"